export default __webpack_public_path__ + "static/media/editarDark.76930ae4.svg";